<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/studyabroad' }"
        >升学规划</el-breadcrumb-item
      >
      <el-breadcrumb-item>升学路径</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="contents">
        <el-tabs>
          <el-tab-pane label="升学路径规划">
            <Project />
          </el-tab-pane>
          <el-tab-pane label="升学规划时间表">
            <div class="content">
              <Timeline :timeline-list="dongtai" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCustomTimeAxis } from "@/api/home";
import Timeline from "@/components/Timeline/Timeline.vue";
import Project from "@/components/project/project.vue";
export default {
  name: "XSentrancepath",
  components: {
    Timeline,
    Project,
  },
  data() {
    return {
      dongtai: "",
      a:1
    };
  },

  async mounted() {
    const res = await GetCustomTimeAxis();
    this.dongtai = res.data||res.result;
  },

  methods: {},
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/global.less";
.box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-width: 1050px;
  .contents {
    margin: 2% 1% 0 1%;
    ::v-deep .el-tabs__nav-wrap::after {
      background: #fff !important;
    }
    .content {
      width: 100%;
    }
  }
}
</style>